<template>
  <div class="Page-schematics">
    <!-- Hero Section -->
    <section class="Hero">
      <h1>Conception de Schémas Électroniques</h1>
      <p class="Hero-subtitle">
        De l'idée au prototype : nous concevons vos circuits électroniques sur-mesure
      </p>
    </section>

    <!-- Services détaillés -->
    <section class="Services">
      <h2>Nos Expertises en Conception</h2>
      <div class="ServicesGrid">
        <div class="ServiceCard">
          <div class="ServiceIcon">⚡</div>
          <h3>Schémas Électroniques</h3>
          <p>Conception complète de vos circuits, du schéma de principe à la réalisation finale.</p>
          <ul>
            <li>Analyse des besoins</li>
            <li>Schéma de principe</li>
            <li>Calculs et dimensionnement</li>
            <li>Validation par simulation</li>
          </ul>
        </div>

        <div class="ServiceCard">
          <div class="ServiceIcon">🔧</div>
          <h3>Routage PCB</h3>
          <p>Transformation de vos schémas en circuits imprimés optimisés et manufacturables.</p>
          <ul>
            <li>Placement des composants</li>
            <li>Routage multi-couches</li>
            <li>Respect des règles DRC</li>
            <li>Optimisation EMC/EMI</li>
          </ul>
        </div>

        <div class="ServiceCard">
          <div class="ServiceIcon">📊</div>
          <h3>Simulation & Tests</h3>
          <p>Validation de vos designs avant fabrication grâce à nos outils de simulation avancés.</p>
          <ul>
            <li>Simulation SPICE</li>
            <li>Tests de compatibilité</li>
            <li>Validation fonctionnelle</li>
          </ul>
        </div>

    
      </div>
    </section>

    <!-- Process Section -->
    <section class="Process">
      <h2>Notre Processus de Conception</h2>
      <div class="ProcessSteps">
        <div class="Step">
          <div class="StepNumber">1</div>
          <h3>Analyse</h3>
          <p>Étude de vos besoins et contraintes techniques</p>
        </div>
        <div class="StepArrow">→</div>
        <div class="Step">
          <div class="StepNumber">2</div>
          <h3>Conception</h3>
          <p>Création du schéma électronique et choix des composants</p>
        </div>
        <div class="StepArrow">→</div>
        <div class="Step">
          <div class="StepNumber">3</div>
          <h3>Simulation</h3>
          <p>Validation par simulation et optimisation</p>
        </div>
        <div class="StepArrow">→</div>
        <div class="Step">
          <div class="StepNumber">4</div>
          <h3>Prototype</h3>
          <p>Réalisation et tests du prototype fonctionnel</p>
        </div>
        <div class="StepArrow">→</div>
        <div class="Step">
          <div class="StepNumber">5</div>
          <h3>Produit final</h3>
          <p>Réalisation du produit fonctionnel final</p>
        </div>
      </div>
    </section>

    <!-- Technologies Section -->
    <section class="Technologies">
      <h2>Outils & Technologies</h2>
      <div class="TechGrid">
        <div class="TechCard">
          <h4>Logiciels CAO</h4>
          <ul>
            <li>KiCad</li>
            <li>Altium Designer</li>
            <li>Eagle</li>
            <li>EasyEDA</li>
          </ul>
        </div>
        <div class="TechCard">
          <h4>Simulation</h4>
          <ul>
            <li>LTSpice</li>
            <li>Proteus</li>
            <li>Multisim</li>
          </ul>
        </div>
        <div class="TechCard">
          <h4>Domaines</h4>
          <ul>
            <li>Électronique analogique</li>
            <li>Électronique numérique</li>
            <li>Microcontrôleurs</li>
            <li>IoT & Communication</li>
          </ul>
        </div>
      </div>
    </section>

    <!-- CTA Section -->
    <section class="CTA">
      <div class="CTAContent">
        <h2>Prêt à Concrétiser Votre Projet ?</h2>
        <p>Contactez-nous pour discuter de vos besoins en conception électronique</p>
        <button class="CTAButton">Demander un Devis</button>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Page-Schematics'
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@700;400&display=swap');

.Page-schematics {
  min-height: 100vh;
  font-family: 'Montserrat', Arial, sans-serif;
  color: #fff;
}

/* Hero Section */
.Hero {
  text-align: Left;
  padding: 4rem 2rem;
  
}

.Hero h1 {
  text-align: Left;
  font-family: deonstudio;
  font-size: 3rem;
  margin-bottom: 1rem;
  color: var(--text-secondary);
  
}

.Hero-subtitle {
  text-align: Left;
  font-size: 1.3rem;
  color: var(--text-muted);
  max-width: 600px;
  
  line-height: 1.6;
}

/* Services Section */
.Services {
  padding: 4rem 2rem;
  max-width: 1200px;
  margin: 0 auto;
  
}

.Services h2 {
  font-family: deonstudio;
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 3rem;
  color: var(--text-secondary);
}

.ServicesGrid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
  margin-bottom: 2rem;
}

.ServiceCard {
  background-color: var(--bg-tertiary);
  border-radius: var(--radius-small);
  padding: var(--spacing-lg);
  min-height: 320px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  transition: all var(--transition-normal);
  position: relative;
  overflow: hidden;
  box-shadow:  5px 5px 10px #d9d9d9,
              -5px -5px 10px #ffffff;
}

.ServiceCard:hover {
  transform: translateY(-8px);
  box-shadow: 0 8px 32px rgba(118, 153, 212, 0.2);
}

.ServiceIcon {
  font-size: 3rem;
  text-align: center;
  margin-bottom: 1rem;
  filter: grayscale(0.3);
}

.ServiceCard h3 {
  font-family: deonstudio;
  color: var(--text-secondary);
  font-size: 1.4rem;
  margin-bottom: 1rem;
  text-align: center;
}

.ServiceCard p {
  color: #bfc9e0;
  margin-bottom: 1.5rem;
  line-height: 1.6;
}

.ServiceCard ul {
  list-style: none;
  padding: 0;
}

.ServiceCard li {
  color:var(--text-muted);
  padding: 0.3rem 0;
  position: relative;
  padding-left: 1.5rem;
}

.ServiceCard li::before {
  content: "▸";
  color: var(--text-secondary);
  position: absolute;
  left: 0;
}

/* Process Section */
.Process {
  padding: 4rem 2rem;
  background-color: var(--bg-tertiary);
  border-radius: var(--radius-small);
  box-shadow:  5px 5px 10px #d9d9d9,
              -5px -5px 10px #ffffff;
}

.Process h2 {
  font-family: deonstudio;
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 3rem;
  color: var(--text-secondary);
}

.ProcessSteps {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 2rem;
  max-width: 1000px;
  margin: 0 auto;
}

.Step {
  text-align: center;
  flex: 1;
  min-width: 200px;
}

.StepNumber {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: var(--text-secondary);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: bold;
  margin: 0 auto 1rem auto;
  font-family: deonstudio;
}

.Step h3 {
  font-family: deonstudio;
  color: var(--text-secondary);
  margin-bottom: 0.5rem;
}

.Step p {
  color: #bfc9e0;
  font-size: 0.9rem;
  line-height: 1.4;
}

.StepArrow {
  font-size: 2rem;
  color: var(--text-secondary);
  font-weight: bold;
}

/* Technologies Section */
.Technologies {
  padding: 4rem 2rem;
  max-width: 1000px;
  margin: 0 auto;
}

.Technologies h2 {
  font-family: deonstudio;
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 3rem;
  color: var(--text-secondary);
}

.TechGrid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
}

.TechCard {
  
  border-radius: 12px;
  padding: 2rem;
  
  background-color: var(--bg-tertiary);
  border-radius: var(--radius-small);
  box-shadow:  5px 5px 10px #d9d9d9,
              -5px -5px 10px #ffffff;
}

.TechCard h4 {
  font-family: deonstudio;
  color: var(--text-secondary);
  margin-bottom: 1rem;
  text-align: center;
}

.TechCard ul {
  list-style: none;
  padding: 0;
}

.TechCard li {
  color: var(--text-muted);
  padding: 0.4rem 0;
  text-align: center;
  border-bottom: 1px solid rgba(118, 153, 212, 0.1);
}

.TechCard li:last-child {
  border-bottom: none;
}

/* CTA Section */
.CTA {
  padding: 4rem 2rem;
  background-color: var(--bg-tertiary);
  border-radius: var(--radius-small);
  box-shadow:  5px 5px 10px #d9d9d9,
              -5px -5px 10px #ffffff;
  text-align: center;
  margin-bottom: 2%;
}

.CTAContent h2 {
  font-family: deonstudio;
  font-size: 2.5rem;
  margin-bottom: 1rem;
  color: var(--text-secondary);;
}

.CTAContent p {
  font-size: 1.2rem;
  margin-bottom: 2rem;
  color: var(--text-muted);
}

.CTAButton {
  background: var(--bg-secondary);
  color: white;
  border: none;
  padding: 1rem 2rem;
  font-size: 1.1rem;
  border-radius: 8px;
  cursor: pointer;
  font-family: deonstudio;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0,0,0,0.2);
}

.CTAButton:hover {
  background:  var(--bg-secondary);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0,0,0,0.3);
}

/* Responsive */
@media (max-width: 768px) {
  .Hero h1 {
    font-size: 2.2rem;
  }
  
  .Hero-subtitle {
    font-size: 1.1rem;
  }
  
  .ProcessSteps {
    flex-direction: column;
  }
  
  .StepArrow {
    transform: rotate(90deg);
  }
  
  .Services h2,
  .Process h2,
  .Technologies h2,
  .CTAContent h2 {
    font-size: 2rem;
  }
  
  .ServicesGrid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .Hero {
    padding: 2rem 1rem;
  }
  
  .Services,
  .Process,
  .Technologies,
  .CTA {
    padding: 2rem 1rem;
  }
  
  .ServiceCard,
  .TechCard {
    padding: 1.5rem;
  }
}
</style>